import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {Box, useSlotRecipe} from '@chakra-ui/react3'
import ModuleContainer from '../../components/module-container'
import CTA from '../../components/cms/cta'
import RichText from '../../components/cms/rich-text'
import textBannerSlotRecipe, {CTA_VARIANT_MAP} from './index.recipe'
import {Chakra3Theme} from '../../theme'

const TextBanner = React.forwardRef(
    (
        {
            moduleId,
            moduleType,
            pageId,
            anchor,
            copy,
            cta,
            colorWorld,
            textColor: color,
            backgroundColor,
            spacing
        },
        ref
    ) => {
        const recipe = useSlotRecipe({recipe: textBannerSlotRecipe})
        const styles = useMemo(() => recipe({colorWorld}), [recipe, colorWorld])

        const ctaVariant = CTA_VARIANT_MAP[colorWorld]?.[cta?.variant]

        return (
            <ModuleContainer
                moduleId={moduleId}
                moduleType={moduleType}
                pageId={pageId}
                anchor={anchor}
                spacing={spacing}
                modulePadding={spacing === 'none' ? 'none' : 'default'}
                background="none"
                ref={ref}
            >
                <Chakra3Theme theme="light">
                    <Box
                        css={[
                            styles.root,
                            {
                                ...(backgroundColor && {'--banner-bg': backgroundColor}),
                                ...(color && {'--banner-color': color})
                            }
                        ]}
                    >
                        <Box css={styles.contentContainer}>
                            {copy?.text && (
                                <Box css={styles.copyWrapper}>
                                    <RichText>{copy.text}</RichText>
                                </Box>
                            )}
                            {cta?.label && (
                                <Box css={styles.ctaWrapper}>
                                    <CTA
                                        {...cta}
                                        size="sm"
                                        variant={ctaVariant}
                                        trackingContext={{
                                            moduleName: moduleType,
                                            eventLabel: 'cta'
                                        }}
                                    />
                                </Box>
                            )}
                        </Box>
                    </Box>
                </Chakra3Theme>
            </ModuleContainer>
        )
    }
)

if (process.env.NODE_ENV !== 'production') {
    TextBanner.displayName = 'TextBanner'
}

TextBanner.propTypes = {
    anchor: PropTypes.string,
    copy: PropTypes.shape({
        text: PropTypes.string
    }),
    cta: PropTypes.object,
    colorWorld: PropTypes.oneOf(Object.keys(textBannerSlotRecipe.variants.colorWorld)),
    textColor: PropTypes.string,
    backgroundColor: PropTypes.string,
    spacing: PropTypes.oneOf(['default', 'reduced', 'min', 'min-top', 'min-bottom', 'none']),
    moduleId: PropTypes.string,
    moduleType: PropTypes.string,
    pageId: PropTypes.string
}

export default TextBanner
